/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportDeleteConnectionMutationResponse, SocialExportDeleteConnectionPathParams, SocialExportDeleteConnection401, SocialExportDeleteConnection403, SocialExportDeleteConnection404 } from "../models/SocialExportDeleteConnection";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { socialExportDeleteConnection } from "../axios/socialExportDeleteConnection";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const socialExportDeleteConnectionMutationKey = () => [{ url: '/social-export/v1/connections/:id' }] as const

export type SocialExportDeleteConnectionMutationKey = ReturnType<typeof socialExportDeleteConnectionMutationKey>

export function socialExportDeleteConnectionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = socialExportDeleteConnectionMutationKey()
        return mutationOptions<SocialExportDeleteConnectionMutationResponse, ResponseErrorConfig<SocialExportDeleteConnection401 | SocialExportDeleteConnection403 | SocialExportDeleteConnection404>, {id: SocialExportDeleteConnectionPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return socialExportDeleteConnection(id, config)
          },
        })

}

/**
 * @description Disconnects and permanently deletes a connection owned by the authenticated client.
 * @summary Delete a connection by id
 * {@link /social-export/v1/connections/:id}
 */
export function useSocialExportDeleteConnection<TContext>(options: 
{
  mutation?: UseMutationOptions<SocialExportDeleteConnectionMutationResponse, ResponseErrorConfig<SocialExportDeleteConnection401 | SocialExportDeleteConnection403 | SocialExportDeleteConnection404>, {id: SocialExportDeleteConnectionPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? socialExportDeleteConnectionMutationKey()

          const baseOptions = socialExportDeleteConnectionMutationOptions(config) as UseMutationOptions<SocialExportDeleteConnectionMutationResponse, ResponseErrorConfig<SocialExportDeleteConnection401 | SocialExportDeleteConnection403 | SocialExportDeleteConnection404>, {id: SocialExportDeleteConnectionPathParams["id"]}, TContext>
          

          return useMutation<SocialExportDeleteConnectionMutationResponse, ResponseErrorConfig<SocialExportDeleteConnection401 | SocialExportDeleteConnection403 | SocialExportDeleteConnection404>, {id: SocialExportDeleteConnectionPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SocialExportDeleteConnectionMutationResponse, ResponseErrorConfig<SocialExportDeleteConnection401 | SocialExportDeleteConnection403 | SocialExportDeleteConnection404>, {id: SocialExportDeleteConnectionPathParams["id"]}, TContext>
      
}